import { FloatingTooltip } from '../components/Floating'
import { Link } from '../components/Link'
import { EMPTY_STRING } from '../constants/common'
import { HTML_LINK_TARGET } from '../constants/html'
import { REG_EXP_URL_IN_TEXT } from '../constants/regExp'

import { stopPropagation } from './events'

/**
 * Returns parsed text as array of either string or html <a> element
 */
export function linkifyText({ text, tooltip }) {
  if (!text) {
    return EMPTY_STRING
  }

  const res = []

  text.replace(REG_EXP_URL_IN_TEXT, (_, link, text) => {
    res.push(
      link ? (
        <FloatingTooltip content={tooltip} key={res.length}>
          <Link
            rel='noreferrer'
            target={HTML_LINK_TARGET.blank}
            to={`${link.startsWith('www') ? '//' : EMPTY_STRING}${link}`} // need to correct redirect, without `//` redirect will be on current site
            onClick={stopPropagation}
          >
            {link}
          </Link>
        </FloatingTooltip>
      ) : (
        text
      )
    )
  })

  return res
}
